export const ReturnRONPOLabel = "Return";
export const ROReturn = "RO Return";
export const POReturn = "PO Return";
export const ADDPOReturn = "Add PO Return";
export const EDITPOReturn = "Edit PO Return";
export const VIEWPOReturn = "View PO Return";
export const ADDROReturn = "Add RO Return";
export const EDITROReturn = "Edit RO Return";
export const VIEWROReturn = "View RO Return";
export const ROReturnHistoryLabel = "RO Return History";
export const POReturnHistoryLabel = "PO Return History";

export const ROReturnLabels = {
  Return: "Return",
  Delete: "Delete",
  Edit: "Edit",
  Draft: "Draft",
  Publish: "Publish",
  Published: "Published",
  View: "View",
  History: "History",
  Partially_returned: "Partially_returned",
  fully_returned: "fully_returned",
  make_PO: "Add PO",
  import : "Import"
};